// only for prod
// eslint-disable-next-line import/prefer-default-export
export const REGION_DOMAINS = {
  US: 'https://app.saucelabs.com',
  EU: 'https://app.eu-central-1.saucelabs.com', // europe
};

export const DOMAINS = {
  PROD: 'https://accounts.saucelabs.com/am/XUI/',
  STAGING: 'https://accounts.staging.saucelabs.net/am/XUI/',
};

// fetch json data
export const JSON_URL = {
  PROD: 'https://accounts.saucelabs.com/am/json',
  STAGING: 'https://accounts.staging.saucelabs.net/am/json',
};

// two Data centers which support features for the platform configurator
export const SUPPORT_DATA_CENTRE = ['us-west-1', 'eu-central-1'];
